<template>
  <b-carousel
    class="banner"
    id="carousel-fade"
    style="text-shadow: 0px 0px 2px #000"
    fade
    indicators
    img-width="1024"
    img-height="480"
  >
    <b-carousel-slide v-for="item in banners" :key="item.id">
      <template #img>
        <div class="banner-item" @click="handleCoverItem(item)">
          <el-image class="banner-cover" :src="item.bannerImgUrl"></el-image>
        </div>
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
export default {
  props: {
    banners: {
      type: Array,
      default: [],
    },
  },
  methods: {
    handleCoverItem(item) {
      window.location.href = item.bannerLinkUrl
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  &-item {
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
  }
  &-cover {
    width: 100%;
    height: 100%;
  }

  ::v-deep .carousel-indicators {
    margin: 0 auto 10px;
  }
}
</style>
